<template>
    <div class="main-block">
        <RecentAnnouncement />
        <EventsBlock/>
    </div>
</template>

<script>
import RecentAnnouncement from './RecentAnnouncement.vue';
import EventsBlock from './EventsBlock.vue';

export default {
  name: 'HrInfo',
  components: {
    RecentAnnouncement,
    EventsBlock
  },
};
</script>
<style>
.main-block {
    border: solid 1px #D5D1C8;
    border-radius: 30px;
    box-sizing: border-box;
    border-top: 0;
}
</style>
